module.exports = {
	"articleTitle1": "Best Thrift/Vintage Shop: Ragstock ",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Ragstock",
	"articleLink2": "https://www.michigandaily.com/arts/best-thriftvintage-store-ragstock",
	"articleSnippet1": "Apr 3, 2016 ... Selling everything from plaid shirts to duck onesies, Ragstock is the place to look \nfor almost any of your clothing needs — think Forever 21 ...",
	"articleSnippet2": "Apr 1, 2014 ... Walking into Ragstock's dimly lit, pattern-filled storefront is like pulling on a \nfamiliar pair of worn-in jeans (the very kind that the store itself ...",
	"totalMisc": 1,
	"articleTitle2": "Best Thrift/Vintage Store: Ragstock",
	"address": "337 E Liberty St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/151028/vel.ART_.Ragstock.10.29.15015.JPG?itok=pz2aaQRE",
			"author": "Virginia Lozano",
			"caption": "Kinesiology Junior Mitchell Tuttle looks for a costume at Ragstock, Wednesday."
		}
	],
	"position": {
		"lat": 42.279582,
		"lng": -83.744584
	},
	"tips": [
		{
			"text": "There are a ton of cool clothes here. It's a thrift store, so the prices are great.",
			"person": "Erik Forkin"
		},
		{
			"text": "This is the prime spot to get a Halloween costume in October.",
			"person": "Erik Forkin"
		}
	],
	"articleLink1": "https://www.michigandaily.com/section/arts/boaa-ragstock",
	"categories": {
		"clothingstore": 1,
		"bestofaa": 1,
		"misc": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/ragstock.json
// module id = 956
// module chunks = 0